import { render, staticRenderFns } from "./Socio.vue?vue&type=template&id=4dd07f9c&lang=pug&"
import script from "./Socio.vue?vue&type=script&lang=js&"
export * from "./Socio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports